import { Helmet } from 'react-helmet-async';
import { SITE, SITE_URL } from '../config/site';

export default function Seo({ title, description, path = '' }) {
  const pageTitle = title ? `${title} | ${SITE.shortName}` : SITE.legalName;
  const pageDescription = description || SITE.description;
  const canonical = SITE_URL ? `${SITE_URL.replace(/\/$/, '')}${path}` : undefined;

  return (
    <Helmet>
      <title>{pageTitle}</title>
      <meta name="description" content={pageDescription} />
      {canonical && <link rel="canonical" href={canonical} />}
      <meta property="og:title" content={pageTitle} />
      <meta property="og:description" content={pageDescription} />
      <meta property="og:type" content="website" />
      {canonical && <meta property="og:url" content={canonical} />}
    </Helmet>
  );
}
